import React from 'react';
import classnames from 'classnames';

import TimeHelpers from '@arreeba/ristoranti-frontend-lib/lib/helpers/time';
import { restaurantById } from '@arreeba/ristoranti-frontend-lib/lib/selectors/booking';

import { getTheme, connect } from '../../util';
import { urlSelector } from '../../selectors/urlSelectors';


const data = {
  pending: {
    icon: 'bi_com-paperplane',
    title: 'La tua prenotazione è in attesa di conferma!',
    body: `A breve riceverai una email di conferma all'indirizzo che ci hai indicato.`,
  },
  confirmed: {
    icon: 'bi_interface-tick',
    title: 'La tua prenotazione è stata confermata!',
    body: `Ti abbiamo inviato una email di conferma all'indirizzo che ci hai indicato.`,
  },
};


const BookingEnd = (props) => {
  const { actions, booking, app, } = props;
  const { createdRequest } = booking;
  // const { bookingRush } = app;
  const status = createdRequest.status.toLowerCase();
  const theme = getTheme(props);

  const targetRestaurant = props.url.restaurantId;
  const restaurant = restaurantById(app.merchant.restaurants, targetRestaurant);

  const locale = 'it';
  const day = TimeHelpers.weekDayLocale(createdRequest.date, locale);
  const date = TimeHelpers.toLocalDate(createdRequest.date, locale);
  const time = createdRequest.availabilitySlot.open;

  const icon = (theme.confirmIcon) ?
    <img src={theme.confirmIcon} role="presentation" /> :
    <i className={data[status].icon} />;
  const iconStatusClasses = classnames(
    'bookingStatusIcon',
    { 'bookingStatusIcon--pending': status === 'pending' },
    { 'bookingStatusIcon--confirmed': status === 'confirmed' },
    { 'bookingStatusIcon--denied': status === 'denied' },
  )

  const resetBookingState = () => {
    actions.booking.endBooking();
  };

  return (
    <main>
      <div className={iconStatusClasses}>
        {icon}
      </div>

      <div className="grow" style={{textAlign: 'center'}}>
        <p>
          <strong>{data[status].title}</strong>
        </p>
        <p>{data[status].body}</p>

        <div className="restaurant-info-panel">
          <p>
            <i className="bi_location-pin" />
            {restaurant.name}, {restaurant.city}
          </p>

          <p>
            <i className="bi_interface-clock" />
            {day} {date} alle {time}<br />
          </p>

          <p>
            <i className="bi_kitchen-fork-knife" />
            x {createdRequest.people} persone
          </p>
        </div>
      </div>

      <a href={`/app/${props.url.appId}`} style={{ display: 'none' }} onClick={resetBookingState}>
        Torna alla Home
      </a>
    </main>
  );
};

const mapStateToProps = (state, props) => ({
  app: state.app,
  booking: state.booking,
  url: urlSelector(state, props),
});
export default connect(BookingEnd, { mapStateToProps });



// WEBPACK FOOTER //
// ./src/containers/booking/booking-end.js